import { axios } from "@Root/API";

export const getColumnOptions = contactType => {
  return axios.get(`page-setting/columns?entity=${contactType}`);
};
